/*
 * ORIMONO measurement guide (v3.1)
 * Mounts the product's drawing from snippets/measurement-guide.liquid into the
 * Kiwi size-chart drawer (replacing the legacy "HOW WE MEASURE" graphic), shows
 * only the measurements that are columns in the product's Kiwi table, re-stacks
 * the labels evenly and links hover / tap between graphic and table.
 * Idempotent; survives Kiwi re-renders and the CM/INCHES toggle.
 * Generated from scratch v3/gen3.py; header synonyms below + translated label titles.
 */
(function () {
  'use strict';
  if (window.__orimonoMeasurementGuide) return;
  window.__orimonoMeasurementGuide = true;

  var LEGACY_IMG_RE = /\/(top|bottom|shoes)\.svg/i;
  var LEGACY_SEL = '.model-sizechart-img';

  /* Header synonyms per measurement concept. Matching ignores case, accents,
     spaces, punctuation and units ("SLEEVE L.", "WAIST*", "Chest (cm)").
     A drawing can alias a concept (bags: width -> depth, shoes: width -> sole_width). */
  var DICT = {
    shoulder: [
      'shoulder', 'shoulders', 'shoulder width', 'across shoulder',
      'schulter', 'schultern', 'schulterbreite',                       // de
      'spalla', 'spalle', 'larghezza spalle',                          // it
      'epaule', 'epaules', 'largeur epaules', 'largeur d epaules',     // fr
      'hombro', 'hombros', 'ancho de hombros', 'ancho hombros',        // es
      '肩幅', '肩',                                                     // ja
      '어깨', '어깨너비', '어깨넓이', '어깨단면',                          // ko
      '肩宽'                                                            // zh-CN
    ],
    chest: [
      'chest', 'bust', 'pit to pit', 'p2p', 'ptp', 'armpit to armpit', 'chest width', 'half chest', '1 2 chest',
      'brust', 'brustweite', 'brustbreite', 'brustumfang', 'achsel zu achsel',
      'petto', 'torace', 'larghezza petto', 'circonferenza petto', 'ascella ascella',
      'poitrine', 'tour de poitrine', 'largeur poitrine', 'aisselle a aisselle',
      'pecho', 'contorno de pecho', 'ancho de pecho', 'axila a axila',
      '身幅', '胸囲', 'バスト', '胸幅',
      '가슴', '가슴단면', '가슴둘레', '가슴너비',
      '胸围', '胸宽'
    ],
    sleeve_length: [
      'sleeve', 'sleeves', 'sleeve l', 'sleeve length', 'sleeve len', 'arm length',
      'armel', 'armellange', 'armel l', 'armlange',
      'manica', 'maniche', 'lunghezza manica', 'lunghezza maniche',
      'manche', 'manches', 'longueur manche', 'longueur de manche', 'longueur manches',
      'manga', 'mangas', 'largo de manga', 'largo manga', 'longitud de manga', 'longitud manga',
      '袖丈', '袖',
      '소매', '소매길이', '소매기장', '팔길이',
      '袖长'
    ],
    sleeve_width: [
      'sleeve w', 'sleeve width', 'bicep', 'biceps', 'upper arm', 'arm width',
      'armelbreite', 'armel b', 'armel w', 'oberarm', 'oberarmweite', 'bizeps',
      'larghezza manica', 'bicipite', 'bicipiti',
      'largeur manche', 'largeur de manche', 'tour de bras',
      'ancho de manga', 'ancho manga', 'contorno de brazo',
      '袖幅', '二の腕', '腕周り',
      '소매통', '소매너비', '소매폭', '소매단면', '팔통',
      '袖宽', '袖肥', '臂围', '袖围'
    ],
    length: [
      'length', 'back length', 'body length', 'total length', 'full length', 'leg length', 'outseam', 'outside leg', 'center back length', 'cb length',
      'lange', 'ruckenlange', 'gesamtlange', 'seitenlange', 'beinlange', 'aussenbeinlange',
      'lunghezza', 'lunghezza totale', 'lunghezza dietro', 'lunghezza schiena', 'lunghezza gamba', 'lunghezza esterna',
      'longueur', 'longueur totale', 'longueur dos', 'longueur jambe', 'longueur exterieure',
      'largo', 'longitud', 'largo total', 'largo de pierna', 'largo pierna', 'largo espalda',
      '着丈', '総丈', '丈', 'パンツ丈', '総長',
      '길이', '총장', '총기장', '기장', '총길이',
      '衣长', '长度', '后中长', '裤长', '总长', '后衣长'
    ],
    waist: [
      'waist', 'waistband', 'waist width', 'half waist', '1 2 waist',
      'bund', 'bundweite', 'taille',          // de "Taille" = waist (fr "TAILLE" = size, only ever the first column, which is skipped)
      'vita', 'girovita', 'larghezza vita',
      'tour de taille', 'ceinture', 'largeur taille',
      'cintura', 'contorno de cintura', 'ancho de cintura',
      'ウエスト', '胴囲',
      '허리', '허리단면', '허리둘레', '허리너비',
      '腰围', '腰宽', '腰'
    ],
    hip: [
      'hip', 'hips', 'seat', 'hip width',
      'hufte', 'huften', 'huftweite', 'gesass', 'gesassweite',
      'fianchi', 'fianco', 'bacino', 'larghezza fianchi',
      'hanche', 'hanches', 'tour de hanches', 'largeur hanches', 'bassin',
      'cadera', 'caderas', 'contorno de cadera', 'ancho de cadera',
      'ヒップ', '尻幅',
      '엉덩이', '힙', '엉덩이단면', '엉덩이둘레',
      '臀围', '臀宽'
    ],
    leg_width: [
      'leg w', 'leg width', 'thigh', 'thigh width', 'thighs',
      'oberschenkel', 'oberschenkelweite', 'schenkel', 'beinweite', 'beinbreite',
      'coscia', 'larghezza coscia', 'larghezza gamba', 'circonferenza coscia',
      'cuisse', 'largeur cuisse', 'tour de cuisse', 'largeur jambe',
      'muslo', 'ancho de muslo', 'contorno de muslo', 'ancho de pierna',
      'ワタリ', 'わたり', 'ワタリ幅', 'もも幅', '太もも', '腿幅',
      '허벅지', '허벅지단면', '허벅지너비', '허벅지둘레',
      '大腿围', '腿围', '腿宽', '横裆', '大腿宽'
    ],
    rise: [
      'rise', 'crotch', 'front rise', 'back rise', 'crotch depth', 'crotch length',
      'leibhohe', 'schritt', 'vordere leibhohe', 'hintere leibhohe', 'schritthohe',
      'cavallo', 'cavallo davanti', 'cavallo anteriore', 'altezza cavallo', 'cavallo dietro',
      'montant', 'fourche', 'hauteur de fourche', 'montant devant', 'montant dos',
      'tiro', 'tiro delantero', 'tiro trasero', 'altura de tiro',
      '股上', '股上丈',
      '밑위', '밑위길이', '앞밑위', '뒷밑위',
      '前裆', '裆深', '直裆', '立裆', '后裆', '裆长'
    ],
    inseam: [
      'inseam', 'inside leg', 'inside leg length', 'inner leg', 'inner leg length', 'inseam length',
      'innenbeinlange', 'schrittlange', 'innenbein',
      'interno gamba', 'lunghezza interna', 'cavallo interno', 'lunghezza interno gamba',
      'entrejambe', 'longueur entrejambe', 'longueur d entrejambe', 'longueur interieure',
      'entrepierna', 'largo de entrepierna', 'largo entrepierna', 'tiro interior',
      '股下', '股下丈',
      '인심', '안쪽기장', '인심길이', '안기장',
      '内长', '内侧长', '内缝长', '内裆长', '内长度'
    ],
    hem: [
      'hem', 'leg opening', 'hem width', 'leg hem', 'opening', 'ankle', 'bottom opening', 'leg opening width',
      'saum', 'saumweite', 'beinoffnung', 'fussweite', 'beinabschluss',
      'orlo', 'fondo', 'fondo gamba', 'apertura gamba', 'larghezza fondo', 'larghezza orlo',
      'ourlet', 'bas de jambe', 'ouverture jambe', 'ouverture de jambe', 'largeur bas', 'largeur du bas',
      'bajo', 'dobladillo', 'boca de pierna', 'ancho de bajo', 'bajo de pierna', 'ancho bajo',
      '裾幅', '裾',
      '밑단', '밑단단면', '밑단너비', '밑단둘레',
      '裤口', '脚口', '裤脚口', '裤脚'
    ],
    insole: [
      'insole', 'insole length', 'foot length', 'inner sole',
      'innensohle', 'einlegesohle', 'innensohlenlange', 'sohlenlange innen', 'fusslange',
      'soletta', 'lunghezza soletta', 'plantare', 'sottopiede',
      'semelle interieure', 'longueur semelle', 'longueur semelle interieure', 'premiere',
      'plantilla', 'largo de plantilla', 'longitud de plantilla',
      'インソール', '中敷き', '中敷', 'インソール長',
      '깔창', '인솔', '깔창길이', '발길이',
      '内底长', '鞋垫长', '鞋垫', '内长底'
    ],
    sole_width: [
      'sole width', 'sole w', 'outsole width', 'sole',
      'sohlenbreite', 'sohle', 'laufsohlenbreite',
      'larghezza suola', 'suola',
      'largeur semelle', 'largeur de semelle', 'semelle',
      'ancho de suela', 'ancho suela', 'suela',
      'ソール幅', 'ソール', '靴幅',
      '밑창너비', '아웃솔너비', '밑창', '발볼',
      '鞋底宽', '鞋底', '底宽'
    ],
    sole_height: [
      'sole height', 'heel height', 'sole h', 'platform', 'heel',
      'sohlenhohe', 'absatzhohe', 'absatz', 'altezza suola', 'altezza tacco', 'tacco',
      'hauteur de semelle', 'hauteur semelle', 'hauteur talon', 'hauteur du talon', 'talon',
      'alto de suela', 'altura de suela', 'altura de tacon', 'tacon',
      'ソールの高さ', 'ソール高', 'ヒール高', 'ヒール', '굽 높이', '굽높이', '밑창 높이', '굽', '鞋底高', '跟高', '鞋跟高'
    ],
    shaft_height: [
      'shaft height', 'shaft', 'boot height', 'shaft h', 'leg height',
      'schafthohe', 'schaft', 'altezza gambale', 'gambale', 'hauteur de tige', 'hauteur tige', 'tige',
      'alto de cana', 'altura de cana', 'cana', 'シャフト高', '筒丈', 'シャフト', '샤프트 높이', '목 높이', '샤프트', '靴筒高', '筒高'
    ],
    shaft_girth: [
      'shaft girth', 'shaft width', 'shaft circumference', 'calf', 'shaft opening', 'calf circumference',
      'schaftweite', 'schaftumfang', 'wadenumfang', 'circonferenza gambale', 'tour de tige', 'tour de mollet',
      'contorno de cana', 'contorno de pantorrilla', 'シャフト周り', '筒周り', '샤프트 둘레', '靴筒围', '筒围'
    ],
    height: [
      'height', 'h', 'hohe', 'altezza', 'hauteur', 'alto', 'altura', '高さ', '높이', '高', '高度'
    ],
    width: [
      'width', 'w', 'wide', 'breite', 'larghezza', 'largeur', 'ancho', 'anchura', '幅', '너비', '폭', '宽', '宽度'
    ],
    depth: [
      'depth', 'gusset', 'd', 'tiefe', 'profondita', 'profondeur', 'soufflet', 'profundidad', 'fuelle',
      'マチ', '奥行', '奥行き', '깊이', '두께', '厚', '厚度', '深', '深度'
    ],
    handle_drop: [
      'handle drop', 'handle height', 'handle', 'handles', 'drop', 'henkelhohe', 'henkel', 'griffhohe',
      'altezza manici', 'manici', 'hauteur des anses', 'hauteur anse', 'anses', 'caida de asas', 'asas',
      '持ち手の高さ', '持ち手', '손잡이 높이', '손잡이', '提手高度', '提手'
    ],
    strap_drop: [
      'strap drop', 'strap length', 'strap', 'shoulder strap', 'riemenhohe', 'riemenlange', 'riemen', 'schulterriemen',
      'altezza tracolla', 'lunghezza tracolla', 'tracolla', 'hauteur de bandouliere', 'longueur bandouliere', 'bandouliere',
      'caida de correa', 'largo de correa', 'correa', 'ショルダーの高さ', 'ショルダー', 'ストラップ', '스트랩 높이', '스트랩', '肩带高度', '肩带长', '肩带'
    ],
    lens_width: [
      'lens', 'lense', 'lens width', 'lense width', 'lenses', 'eye size',
      'glasbreite', 'glas', 'larghezza lente', 'lente', 'calibro', 'largeur du verre', 'largeur verre', 'verre', 'calibre',
      'ancho de lente', 'lentes', 'レンズ幅', 'レンズ', '렌즈 너비', '렌즈', '镜片宽', '镜片'
    ],
    bridge: [
      'bridge', 'bridge width', 'nose bridge', 'steg', 'stegbreite', 'ponte', 'pont', 'puente',
      'ブリッジ', '브릿지', '브리지', '鼻梁', '鼻梁宽'
    ],
    temple: [
      'temple', 'temples', 'temple length', 'arm length', 'bugel', 'bugellange', 'asta', 'aste', 'lunghezza aste',
      'branche', 'branches', 'longueur des branches', 'varilla', 'varillas', 'テンプル', 'テンプル長', '다리 길이', '다리', '镜腿', '镜腿长'
    ],
    min_girth: [
      'min girth', 'minimum girth', 'min waist', 'min', 'min umfang', 'minimum', 'circ min', 'tour min', 'contorno min',
      '最小周囲', '最小', '최소 둘레', '최소', '最小围度', '最小腰围'
    ],
    max_girth: [
      'max girth', 'maximum girth', 'max waist', 'max', 'max umfang', 'maximum', 'circ max', 'tour max', 'contorno max',
      '最大周囲', '最大', '최대 둘레', '최대', '最大围度', '最大腰围'
    ],
    circumference: [
      'circumference', 'circ', 'girth', 'head circumference', 'inner circumference', 'umfang', 'kopfumfang', 'innenumfang',
      'circonferenza', 'circonference', 'tour de tete', 'circunferencia', 'contorno', 'perimetro',
      '内周', '頭周り', '周囲', '둘레', '머리둘레', '内周长', '周长', '头围'
    ],
    chain_length: [
      'chain length', 'chain', 'kettenlange', 'kette', 'lunghezza catena', 'catena', 'longueur de chaine', 'chaine',
      'largo de cadena', 'cadena', 'チェーンの長さ', 'チェーン', '체인 길이', '체인', '链长', '链条长度'
    ],
    cuff: [
      'cuff', 'cuffs', 'cuff width', 'sleeve opening', 'sleeve opening width', 'sleeve hem', 'wrist', 'sleeve end',
      'armeloffnung', 'armelsaum', 'armelabschluss', 'manschette', 'bundchen',
      'polsino', 'polsini', 'fondo manica', 'apertura manica', 'orlo manica',
      'poignet', 'poignets', 'bas de manche', 'ouverture de manche', 'ouverture manche',
      'puno', 'punos', 'bajo de manga', 'abertura de manga', 'boca de manga',
      '袖口', '袖口幅', '소매단', '소매 끝', '소매부리', '소매끝단면', '袖口宽', '袖口围'
    ],
    knee: [
      'knee', 'knee width', 'knee opening', 'knie', 'knieweite', 'kniebreite', 'ginocchio', 'larghezza ginocchio',
      'genou', 'largeur genou', 'largeur au genou', 'rodilla', 'ancho de rodilla', 'ancho rodilla',
      '膝幅', '膝', '무릎', '무릎단면', '무릎너비', '膝围', '膝宽'
    ],
    lens_height: [
      'lens height', 'lense height', 'lens h', 'glashohe', 'altezza lente', 'hauteur du verre', 'hauteur verre',
      'alto de lente', 'altura de lente', 'レンズ高', 'レンズ高さ', 'レンズ縦幅', '렌즈 높이', '镜片高', '镜片高度'
    ],
    brim: [
      'brim', 'brim width', 'brim length', 'visor', 'peak', 'krempe', 'krempenbreite', 'schirm', 'schirmlange',
      'tesa', 'visiera', 'bord', 'largeur du bord', 'visiere', 'ala', 'visera', 'つば', 'つば幅', 'ツバ', 'ツバ幅',
      '챙', '챙 길이', '챙길이', '帽檐', '帽檐宽', '帽舌'
    ],
    diameter: [
      'diameter', 'inner diameter', 'inside diameter', 'dia', 'durchmesser', 'innendurchmesser', 'diametro', 'diametro interno',
      'diametre', 'diametre interieur', 'diametro interior', '直径', '内径', '지름', '안지름', '내경'
    ],
    pendant: [
      'pendant', 'pendant size', 'pendant height', 'anhanger', 'pendente', 'ciondolo', 'pendentif', 'colgante',
      'ペンダント', 'ペンダントトップ', '펜던트', '吊坠'
    ]
  };

  function compact(s) { return s.replace(/\s+/g, ''); }

  function normalise(text) {
    var s = String(text || '');
    try { s = s.normalize('NFKC'); } catch (e) {}
    s = s.toLowerCase();
    try { s = s.normalize('NFD').replace(/[̀-ͯ]/g, '').normalize('NFC'); } catch (e) {}
    s = s.replace(/ß/g, 'ss');
    s = s.replace(/[(（\[][^)）\]]*[)）\]]/g, ' ');                // "(cm)", "（cm）"
    s = s.replace(/[*.:'’`´/\\_\-–—,;#|+]/g, ' ');
    s = s.replace(/(^|\s)(cm|in|inch|inches|mm|厘米|センチ|센티)(?=\s|$)/g, ' ');
    return s.replace(/\s+/g, ' ').trim();
  }


  var EXTRA = {"shoulder": ["HOMBROS", "SCHULTERN", "SHOULDERS", "SPALLE", "ÉPAULES", "肩宽", "肩幅", "어깨"], "chest": ["BRUST", "CHEST", "PECHO", "POITRINE", "TORACE", "胸宽", "身幅", "가슴"], "sleeve_length": ["LARGO DE MANGA", "LONGUEUR DE MANCHE", "LUNGHEZZA MANICA", "SLEEVE LENGTH", "ÄRMELLÄNGE", "袖丈", "袖长", "소매 길이"], "sleeve_width": ["ANCHO DE MANGA", "LARGEUR DE MANCHE", "LARGHEZZA MANICA", "SLEEVE WIDTH", "ÄRMELWEITE", "袖宽", "袖幅", "소매 너비"], "length": ["BEINLÄNGE", "LARGO", "LARGO DE PIERNA", "LEG LENGTH", "LENGTH", "LONGUEUR", "LONGUEUR DE JAMBE", "LUNGHEZZA", "LUNGHEZZA GAMBA", "LÄNGE", "全長", "总长", "横幅", "着丈", "総丈", "衣长", "裤长", "長さ", "长", "长度", "가로", "길이", "총길이", "총장"], "waist": ["BUND", "CINTURA", "TAILLE", "TOUR DE TAILLE", "VITA", "WAIST", "ウエスト", "腰宽", "허리"], "hip": ["CADERA", "FIANCHI", "HANCHES", "HIP", "HÜFTE", "ヒップ", "臀宽", "엉덩이"], "leg_width": ["COSCIA", "CUISSE", "LEG WIDTH", "MUSLO", "OBERSCHENKEL", "ワタリ", "腿宽", "허벅지"], "inseam": ["ENTREJAMBE", "ENTREPIERNA", "INNENBEINLÄNGE", "INSEAM", "INTERNO GAMBA", "内长", "股下", "인심"], "rise": ["CAVALLO", "CROTCH", "LEIBHÖHE", "MONTANT", "TIRO", "立裆", "股上", "밑위"], "hem": ["BAJO", "BAS", "BAS DE JAMBE", "FONDO", "HEM", "SAUMWEITE", "下摆", "裤口", "裾幅", "밑단"], "insole": ["INNENSOHLE", "INSOLE", "PLANTILLA", "SEMELLE INTÉRIEURE", "SOLETTA", "インソール", "内底长", "깔창"], "sole_width": ["ANCHO DE SUELA", "LARGEUR DE SEMELLE", "LARGHEZZA SUOLA", "SOHLENBREITE", "SOLE WIDTH", "ソール幅", "鞋底宽", "밑창 너비"], "sole_height": ["ALTEZZA SUOLA", "ALTO DE SUELA", "HAUTEUR DE SEMELLE", "SOHLENHÖHE", "SOLE HEIGHT", "ソールの高さ", "鞋底高", "밑창 높이"], "shaft_height": ["ALTEZZA GAMBALE", "ALTO DE CAÑA", "HAUTEUR DE TIGE", "SCHAFTHÖHE", "SHAFT HEIGHT", "シャフト高", "靴筒高", "샤프트 높이"], "shaft_girth": ["CIRCONFERENZA GAMBALE", "CONTORNO DE CAÑA", "SCHAFTWEITE", "SHAFT GIRTH", "TOUR DE TIGE", "シャフト周り", "靴筒围", "샤프트 둘레"], "height": ["ALTEZZA", "ALTO", "HAUTEUR", "HEIGHT", "HÖHE", "高", "高さ", "高度", "높이"], "depth": ["DEPTH", "PROFONDEUR", "PROFONDITÀ", "PROFUNDIDAD", "TIEFE", "マチ", "深度", "깊이"], "handle_drop": ["ALTEZZA MANICI", "CAÍDA DE ASAS", "HANDLE DROP", "HAUTEUR DES ANSES", "HENKELHÖHE", "持ち手の高さ", "提手高度", "손잡이 높이"], "strap_drop": ["ALTEZZA TRACOLLA", "CAÍDA DE CORREA", "HAUTEUR DE BANDOULIÈRE", "RIEMENHÖHE", "STRAP DROP", "ショルダーの高さ", "肩带高度", "스트랩 높이"], "lens_width": ["ANCHO DE LENTE", "GLASBREITE", "LARGEUR DU VERRE", "LARGHEZZA LENTE", "LENS WIDTH", "レンズ幅", "镜片宽", "렌즈 너비"], "bridge": ["BRIDGE", "PONT", "PONTE", "PUENTE", "STEG", "ブリッジ", "鼻梁", "브릿지"], "temple": ["ASTA", "BRANCHE", "BÜGEL", "TEMPLE", "VARILLA", "テンプル", "镜腿", "다리 길이"], "width": ["ANCHO", "ANCHO DEL COLGANTE", "ANHÄNGERBREITE", "BREITE", "LARGEUR", "LARGEUR DU PENDENTIF", "LARGHEZZA", "LARGHEZZA PENDENTE", "PENDANT WIDTH", "WIDTH", "フレーム幅", "ペンダント幅", "吊坠宽", "宽度", "幅", "框宽", "너비", "펜던트 너비", "프레임 너비"], "circumference": ["CIRCONFERENZA", "CIRCONFÉRENCE", "CIRCUMFERENCE", "CIRCUNFERENCIA", "CONTORNO", "TOUR DE MAIN", "TOUR DE TÊTE", "UMFANG", "内周", "内周长", "头围", "手囲", "掌围", "頭周り", "둘레"], "min_girth": ["CIRC. MIN.", "CONTORNO MÍN.", "MIN. GIRTH", "MIN. UMFANG", "TOUR MIN.", "最小周囲", "最小围度", "최소 둘레"], "max_girth": ["CIRC. MAX.", "CONTORNO MÁX.", "MAX. GIRTH", "MAX. UMFANG", "TOUR MAX.", "最大周囲", "最大围度", "최대 둘레"], "chain_length": ["CHAIN LENGTH", "KETTENLÄNGE", "LARGO DE CADENA", "LONGUEUR DE CHAÎNE", "LUNGHEZZA CATENA", "チェーンの長さ", "链长", "체인 길이"], "pendant": ["ANHÄNGER", "COLGANTE", "PENDANT", "PENDENTE", "PENDENTIF", "ペンダント", "吊坠", "펜던트"], "cuff": ["CUFF", "POIGNET", "POLSINO", "PUÑO", "ÄRMELÖFFNUNG", "袖口", "소매단"], "knee": ["GENOU", "GINOCCHIO", "KNEE", "KNIEWEITE", "RODILLA", "膝宽", "膝幅", "무릎"], "lens_height": ["ALTEZZA LENTE", "ALTO DE LENTE", "GLASHÖHE", "HAUTEUR DU VERRE", "LENS HEIGHT", "レンズ高", "镜片高", "렌즈 높이"], "brim": ["ALA", "BORD", "BRIM", "KREMPE", "TESA", "つば", "帽檐", "챙"], "diameter": ["DIAMETER", "DIAMETRO", "DIAMÈTRE", "DIÁMETRO", "DURCHMESSER", "内径", "지름"]};

  var LOOKUP = {};
  function addWord(key, word) {
    var n = normalise(word);
    [n, compact(n)].forEach(function (w) {
      if (!w) return;
      var list = LOOKUP[w] || (LOOKUP[w] = []);
      if (list.indexOf(key) === -1) list.push(key);
    });
  }
  Object.keys(DICT).forEach(function (k) { DICT[k].forEach(function (w) { addWord(k, w); }); });
  Object.keys(EXTRA).forEach(function (k) { EXTRA[k].forEach(function (w) { addWord(k, w); }); });

  /* Kiwi template abbreviations: "SLEEVE L.", "LEG W.", "SHAFT H.", "ÄRMEL B.", "CIRC." ... */
  var ABBR = {
    l: 'length', len: 'length', lg: 'length', lgth: 'length',
    w: 'width', wd: 'width', wdth: 'width', b: 'breite', br: 'breite',
    h: 'height', ht: 'height', hgt: 'height',
    d: 'depth', dp: 'depth', dia: 'diameter', diam: 'diameter',
    circ: 'circumference', circumf: 'circumference', cir: 'circumference', umf: 'umfang',
    larg: 'larghezza', lung: 'lunghezza', alt: 'altezza',
    long: 'longueur', haut: 'hauteur', anch: 'ancho'
  };
  function expand(n) {
    var parts = n.split(' ');
    if (parts.length < 2) return n;
    return parts.map(function (p, i) { return i > 0 && ABBR[p] ? ABBR[p] : p; }).join(' ');
  }

  /* keys: measures present in the drawing; alias: {concept: key} */
  function mapHeader(text, keys, alias) {
    var n = normalise(text);
    if (!n) return null;
    var cands = [n, compact(n)];
    if (/s$/.test(n)) cands.push(n.slice(0, -1), compact(n.slice(0, -1)));
    var x = expand(n);
    if (x !== n) cands.push(x, compact(x));
    for (var i = 0; i < cands.length; i++) {
      var list = LOOKUP[cands[i]];
      if (!list) continue;
      for (var j = 0; j < list.length; j++) {
        var k = list[j];
        if (keys.indexOf(k) !== -1) return k;
        if (alias && alias[k] && keys.indexOf(alias[k]) !== -1) return alias[k];
      }
    }
    return null;
  }

  /* ---------- Kiwi table reading ---------- */

  function cellText(cell) { return (cell.textContent || '').replace(/\s+/g, ' ').trim(); }

  function readLines(table) {
    var rows = Array.prototype.filter.call(table.querySelectorAll('tr'), function (tr) { return tr.closest('table') === table; });
    if (!rows.length) return { horizontal: [], vertical: [] };
    var grid = rows.map(function (tr) {
      var out = [];
      Array.prototype.forEach.call(tr.children, function (cell) {
        var span = Math.max(1, parseInt(cell.getAttribute('colspan'), 10) || 1);
        for (var i = 0; i < span; i++) out.push(cell);
      });
      return out;
    });
    var horizontal = [];
    (grid[0] || []).forEach(function (hc, col) {
      if (col === 0 || grid[0][col - 1] === hc) return;
      var cells = [];
      grid.forEach(function (r) { if (r[col] && cells.indexOf(r[col]) === -1) cells.push(r[col]); });
      horizontal.push({ headerCell: hc, cells: cells });
    });
    var vertical = [];
    grid.forEach(function (r, i) {
      if (i === 0 || !r[0]) return;
      vertical.push({ headerCell: r[0], cells: r.filter(function (c, j) { return j > 0 && c !== r[0]; }).concat([r[0]]) });
    });
    [horizontal, vertical].forEach(function (list) {
      list.forEach(function (line) {
        var data = line.cells.filter(function (c) { return c !== line.headerCell; });
        line.empty = data.length > 0 && data.every(function (c) { return !cellText(c); });
      });
    });
    return { horizontal: horizontal, vertical: vertical };
  }

  /* Robin 2 Nov: hide size-table columns that have no entries (Kiwi renders every template column) */
  var EMPTY_CLS = 'lm-col-empty';
  function hideEmptyColumns(table) {
    var lines = readLines(table).horizontal;
    if (!lines.length) return;
    lines.forEach(function (line) {
      line.cells.forEach(function (c) {
        if ((parseInt(c.getAttribute('colspan'), 10) || 1) > 1) return;
        var on = !!line.empty;
        if (on === c.classList.contains(EMPTY_CLS)) return;
        c.classList.toggle(EMPTY_CLS, on);
        if (on) c.style.setProperty('display', 'none', 'important');
        else c.style.removeProperty('display');
      });
    });
  }
  /* Robin 2 Nov: widen the side drawer instead of wrapping size-table headers onto two lines */
  var WIDE_CLS = 'lm-drawer-wide';
  function fitDrawer(scope, tables) {
    var drawer = scope.closest && scope.closest('.site-drawer');
    if (!drawer) return;
    var reset = function () {
      if (!drawer.classList.contains(WIDE_CLS)) return;
      drawer.classList.remove(WIDE_CLS);
      drawer.style.removeProperty('width');
      drawer.style.removeProperty('--lm-w');
    };
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) { reset(); return; }
    if (!drawer.classList.contains('open')) return;
    var vis = tables.filter(function (t) { return t.offsetParent !== null && t.rows && t.rows.length; });
    if (!vis.length) return;
    reset();
    var extra = 0;
    vis.forEach(function (t) {
      var box = t.parentElement;
      // natural width: measure the table unconstrained, then restore (theme CSS uses a fixed layout)
      var pl = t.style.getPropertyValue('table-layout'), pw = t.style.getPropertyValue('width');
      t.style.setProperty('table-layout', 'auto', 'important');
      t.style.setProperty('width', 'max-content', 'important');
      var natural = t.getBoundingClientRect().width;
      if (pl) t.style.setProperty('table-layout', pl); else t.style.removeProperty('table-layout');
      if (pw) t.style.setProperty('width', pw); else t.style.removeProperty('width');
      extra = Math.max(extra, natural - box.clientWidth);
    });
    if (extra <= 1) return;
    var w = Math.min(Math.ceil(drawer.getBoundingClientRect().width + extra + 40), window.innerWidth - 24);
    drawer.style.setProperty('--lm-w', w + 'px');
    drawer.style.setProperty('width', w + 'px', 'important');
    drawer.classList.add(WIDE_CLS);
  }

  (function () {
    var st = document.createElement('style');
    st.textContent = '.' + EMPTY_CLS + '{display:none!important}' +
      '@media screen and (min-width:768px){' +
      '#eusizeChart.site-drawer table.ks-table,.site-drawer table.ks-table{table-layout:auto!important}' +
      '.site-drawer .ks-table th.ks-table-cell,.site-drawer .ks-table td.ks-table-cell,#eusizeChart .ks-table th.ks-table-cell{white-space:nowrap!important;word-break:normal!important;overflow-wrap:normal!important}' +
      '.site-drawer.' + WIDE_CLS + ':not(.open){right:calc(-1 * var(--lm-w))!important}}';
    (document.head || document.documentElement).appendChild(st);
  })();

  function analyseTable(table, keys, alias) {
    var lines = readLines(table);
    var best = null;
    ['horizontal', 'vertical'].forEach(function (orientation) {
      var cols = {}, count = 0, all = [];
      lines[orientation].forEach(function (line) {
        all.push(line);
        if (line.empty) { line.key = null; return; }
        var key = mapHeader(cellText(line.headerCell), keys, alias);
        line.key = key;
        if (!key) return;
        (cols[key] = cols[key] || []).push(line);
        count++;
      });
      if (!best || count > best.count) best = { orientation: orientation, cols: cols, count: count, lines: all, table: table };
    });
    return best;
  }

  /* ---------- geometry ---------- */

  var PITCH_MIN = 42, PITCH_MAX = 54, R_MIN = 400, JOG = 7, GAP = 1, DESC_MAX = 185, LINE = 13;
  var canvas = null;

  function num(el, name, fallback) {
    var v = parseFloat(el.getAttribute('data-' + name));
    return isNaN(v) ? fallback : v;
  }
  function f(n) { return String(Math.round(n * 100) / 100); }

  function fontOf(el, size) {
    var cs = null;
    try { cs = window.getComputedStyle(el); } catch (e) { cs = null; }
    return ((cs && cs.fontWeight) || '400') + ' ' + size + 'px ' + ((cs && cs.fontFamily) || 'sans-serif');
  }

  function measureString(el, text, size) {
    var w = 0;
    try {
      canvas = canvas || document.createElement('canvas');
      var ctx = canvas.getContext && canvas.getContext('2d');
      if (ctx) { ctx.font = fontOf(el, size); w = ctx.measureText(text).width; }
    } catch (e) { w = 0; }
    if (w > 0) return w;
    for (var i = 0; i < text.length; i++) w += text.charCodeAt(i) > 0x2e80 ? size : size * 0.58;
    return w;
  }

  function measureText(el, size) {
    var w = 0;
    try { w = el.getComputedTextLength(); } catch (e) { w = 0; }
    return w > 0 ? w : measureString(el, el.textContent || '', size);
  }

  /* wraps a description <text> into <tspan> lines no wider than maxW; returns {lines, width} */
  function wrapDesc(el, maxW) {
    var text = el.getAttribute('data-text');
    if (text == null) { text = el.textContent || ''; el.setAttribute('data-text', text); }
    var spaced = /\s/.test(text);
    var tokens = spaced ? text.split(/\s+/) : Array.from ? Array.from(text) : text.split('');
    var lines = [], cur = '';
    tokens.forEach(function (tok) {
      var next = cur ? cur + (spaced ? ' ' : '') + tok : tok;
      if (cur && measureString(el, next, 11) > maxW) { lines.push(cur); cur = tok; }
      else cur = next;
    });
    if (cur) lines.push(cur);
    if (!spaced && lines.length > 1) {
      // keep closing punctuation / brackets with the previous line
      for (var i = 1; i < lines.length; i++) {
        while (/^[）)。、,.]/.test(lines[i])) { lines[i - 1] += lines[i][0]; lines[i] = lines[i].slice(1); }
      }
      lines = lines.filter(Boolean);
    }
    var key = lines.join('\n');
    if (el.getAttribute('data-wrapped') !== key) {
      while (el.firstChild) el.removeChild(el.firstChild);
      lines.forEach(function (line, i) {
        var t = document.createElementNS(SVGNS, 'tspan');
        t.setAttribute('x', '0');
        if (i) t.setAttribute('dy', '13');
        t.textContent = line;
        el.appendChild(t);
      });
      el.setAttribute('data-wrapped', key);
    }
    var width = 0;
    lines.forEach(function (line) { width = Math.max(width, measureString(el, line, 11)); });
    return { lines: lines.length || 1, width: width };
  }

  function points(g) {
    var n = (g.getAttribute('data-pts') || '').trim().split(/\s+/).map(parseFloat);
    var out = [];
    for (var i = 0; i + 1 < n.length; i += 2) out.push([n[i], n[i + 1]]);
    return out;
  }

  function layout(svg) {
    if (!svg) return;
    var ms = Array.prototype.filter.call(svg.querySelectorAll('.mg-m'), function (g) { return !g.hasAttribute('hidden'); });
    if (!ms.length) return;
    var items = ms.map(function (g) {
      var pts = points(g);
      var t = g.querySelector('.mg-title'), d = g.querySelector('.mg-desc');
      var wrap = wrapDesc(d, DESC_MAX);
      return { g: g, pts: pts, a: pts[pts.length - 1], tw: measureText(t, 10), dw: wrap.width, lines: wrap.lines };
    }).sort(function (p, q) { return p.a[1] - q.a[1]; });
    var n = items.length;
    var y0 = items[0].a[1];
    var span = items[n - 1].a[1] - y0;
    var maxLines = 1;
    items.forEach(function (it) { maxLines = Math.max(maxLines, it.lines); });
    var pMin = PITCH_MIN + (maxLines - 1) * LINE;
    var P = n > 1 ? Math.min(Math.max(PITCH_MAX, pMin), Math.max(pMin, span / (n - 1))) : 0;
    var down = [], up = [];
    items.forEach(function (it, i) {
      it.y = y0 + i * P;
      it.jog = null;
      var p = it.pts, L = p.length;
      // a final vertical drop below the garment can simply end on the label row
      if (L > 1 && p[L - 1][0] === p[L - 2][0] && p[L - 1][1] > p[L - 2][1] && it.y >= p[L - 2][1] + 6) {
        it.pts = p.slice(0, L - 1).concat([[p[L - 1][0], it.y]]);
        it.a = it.pts[it.pts.length - 1];
        return;
      }
      if (it.y > it.a[1] + 0.75) down.push(it);
      else if (it.y < it.a[1] - 0.75) up.push(it);
    });
    var gx1 = num(svg, 'gx1', 200), x0 = num(svg, 'x0', 0);
    var jogL = gx1 + 8;
    var slots = down.length + up.length;
    var maxW = 0;
    items.forEach(function (it) { maxW = Math.max(maxW, it.tw, it.dw); });
    var R = Math.max(R_MIN, jogL + slots * JOG + 14 + maxW);
    up.forEach(function (it, k) { it.jog = jogL + k * JOG; });
    down.forEach(function (it, k) { it.jog = jogL + (up.length + down.length - 1 - k) * JOG; });
    items.forEach(function (it) {
      var end = R - it.tw - GAP;
      var d = 'M' + f(it.pts[0][0]) + ' ' + f(it.pts[0][1]);
      for (var i = 1; i < it.pts.length; i++) d += 'L' + f(it.pts[i][0]) + ' ' + f(it.pts[i][1]);
      if (it.jog != null) d += 'H' + f(Math.max(it.jog, it.a[0])) + 'V' + f(it.y);
      d += 'H' + f(end);
      it.g.querySelectorAll('.mg-leader, .mg-leader-bg').forEach(function (p) {
        if (p.getAttribute('d') !== d) p.setAttribute('d', d);
      });
      var label = it.g.querySelector('.mg-label');
      var tr = 'translate(' + f(R) + ' ' + f(it.y) + ')';
      if (label.getAttribute('transform') !== tr) label.setAttribute('transform', tr);
      var hit = it.g.querySelector('.mg-hit');
      var hw = Math.max(it.tw, it.dw) + 6;
      if (hit) { hit.setAttribute('x', f(-hw)); hit.setAttribute('width', f(hw + 2)); hit.setAttribute('height', f(27 + (it.lines - 1) * LINE)); }
    });
    var top = Math.min(num(svg, 'gy0', 0), y0 - 10);
    var bottom = Math.max(num(svg, 'gy1', 0), items[n - 1].y + 20 + (items[n - 1].lines - 1) * LINE);
    var w = R + 2 - x0, h = bottom - top;
    var vb = f(x0) + ' ' + f(top) + ' ' + f(w) + ' ' + f(h);
    if (svg.getAttribute('viewBox') !== vb) {
      svg.setAttribute('viewBox', vb);
      svg.setAttribute('width', f(w));
      svg.setAttribute('height', f(h));
    }
  }

  var SVGNS = 'http://www.w3.org/2000/svg';
  function svgEl(tag, attrs, text) {
    var el = document.createElementNS(SVGNS, tag);
    Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); });
    if (text != null) el.textContent = text;
    return el;
  }

  /* builds leader + label markup for each measure (kept out of the Liquid to keep it small) */
  function hydrate(node) {
    node.querySelectorAll('.mg-m').forEach(function (g) {
      if (g.firstChild) return;
      var title = g.getAttribute('data-t') || '', desc = g.getAttribute('data-d') || '';
      g.setAttribute('tabindex', '0');
      g.setAttribute('role', 'button');
      g.setAttribute('aria-pressed', 'false');
      g.setAttribute('aria-label', title + ': ' + desc);
      g.appendChild(svgEl('path', { 'class': 'mg-leader-bg', d: '' }));
      g.appendChild(svgEl('path', { 'class': 'mg-leader', d: '' }));
      var label = svgEl('g', { 'class': 'mg-label' });
      label.appendChild(svgEl('rect', { 'class': 'mg-hit', x: '-160', y: '-8', width: '162', height: '27' }));
      label.appendChild(svgEl('text', { 'class': 'mg-title', y: '3.5', 'text-anchor': 'end' }, title));
      label.appendChild(svgEl('text', { 'class': 'mg-desc', y: '14.5', 'text-anchor': 'end' }, desc));
      g.appendChild(label);
    });
  }

  function drawingKeys(node) {
    return Array.prototype.map.call(node.querySelectorAll('.mg-m'), function (g) { return g.getAttribute('data-measure'); });
  }
  function drawingAlias(node) {
    var out = {};
    (node.getAttribute('data-alias') || '').split(/\s+/).forEach(function (p) {
      var kv = p.split(':');
      if (kv.length === 2) out[kv[0]] = kv[1];
    });
    return out;
  }

  function setVisible(node, keys) {
    var shown = {};
    node.querySelectorAll('.mg-m').forEach(function (g) {
      var on = keys ? keys.indexOf(g.getAttribute('data-measure')) !== -1 : g.hasAttribute('data-core');
      shown[g.getAttribute('data-measure')] = on;
      if (on) g.removeAttribute('hidden'); else g.setAttribute('hidden', '');
    });
    node.querySelectorAll('[data-for]').forEach(function (el) {
      var on = el.getAttribute('data-for').split(' ').some(function (k) { return shown[k]; });
      if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    layout(node.querySelector('.mg-svg'));
  }

  /* ---------- per-scope state ---------- */

  var tpl = null;
  var states = [];
  var lastPointer = 'mouse';

  function legacyGraphics(scope) {
    var out = Array.prototype.slice.call(scope.querySelectorAll(LEGACY_SEL));
    scope.querySelectorAll('img').forEach(function (img) {
      var src = [img.getAttribute('src'), img.getAttribute('data-src'), img.getAttribute('srcset'), img.getAttribute('data-srcset'), img.currentSrc].join(' ');
      if (LEGACY_IMG_RE.test(src)) out.push(img.closest('.ks-image, .ks-image-and-caption .image-block') || img);
    });
    return out.filter(function (el) { return !el.closest('.mg'); });
  }

  /* the Kiwi table the drawing belongs to: best header match, else the first table that has rows */
  function pickTable(tables, keys, alias) {
    var best = null;
    tables.forEach(function (t) {
      var a = analyseTable(t, keys, alias);
      if (!best || a.count > best.count) best = a;
    });
    if (best && best.count) return best;
    for (var i = 0; i < tables.length; i++) {
      if (tables[i].querySelector('tr')) return { table: tables[i], count: 0, cols: {}, lines: [], orientation: 'horizontal' };
    }
    return null;
  }

  /* mount point: directly after the table block, inside the same Kiwi tab panel, so the drawing is
     visible exactly when the table is (independent of tabs, the legacy image panel or the device) */
  function tableBlock(table, scope) {
    var el = table.closest('.ks-table-content-wrapper') || table.closest('.ks-table-wrapper') || table;
    return scope.contains(el) ? el : table;
  }

  var srcCache = {};
  function drawingSource() {
    var t = template();
    if (!t) return null;
    var garment = t.getAttribute('data-garment');
    if (!garment) return null;
    if (srcCache[garment] === undefined) {
      var src = t.content ? t.content.querySelector('.mg[data-garment="' + garment + '"]') : null;
      srcCache[garment] = src ? { src: src, keys: drawingKeys(src), alias: drawingAlias(src) } : null;
    }
    return srcCache[garment];
  }

  function sync(state) {
    var scope = state.scope;
    if (!scope.isConnected) return;
    var tables = Array.prototype.slice.call(scope.querySelectorAll('table')).filter(function (t) { return !t.closest('.mg'); });

    tables.forEach(hideEmptyColumns);
    fitDrawer(scope, tables);

    var legacy = legacyGraphics(scope);
    legacy.forEach(function (el) { el.classList.add('mg-replaced'); });

    var d = drawingSource();
    // no Kiwi table (not rendered yet / no chart) or no drawing for this category: show nothing
    var analysis = d && tables.length ? pickTable(tables, d.keys, d.alias) : null;
    if (!analysis) {
      if (state.node && state.node.parentNode) state.node.parentNode.removeChild(state.node);
      if (state.table) clearTable(state.table);
      state.node = null; state.anchor = null; state.table = null; state.cols = {};
      return;
    }

    var anchor = tableBlock(analysis.table, scope);
    if (!state.node || !state.node.isConnected || state.anchor !== anchor || state.node.previousSibling !== anchor) {
      if (state.node && state.node.parentNode) state.node.parentNode.removeChild(state.node);
      var node = d.src.cloneNode(true);
      node.setAttribute('data-mg-mounted', '');
      hydrate(node);
      anchor.parentNode.insertBefore(node, anchor.nextSibling);
      state.node = node;
      state.anchor = anchor;
      state.keys = d.keys;
      state.alias = d.alias;
      state.sig = null;
      observeSize(state);
    }

    // shown measures: the table's columns that this drawing can draw; none recognised = core set
    var keys = analysis.count ? state.keys.filter(function (k) { return analysis.cols[k]; }) : null;
    var sig = keys ? keys.join(',') : '*';
    if (state.sig !== sig) { state.sig = sig; setVisible(state.node, keys); }

    if (state.table && state.table !== analysis.table) clearTable(state.table);
    state.table = analysis.count ? analysis.table : null;
    state.cols = state.table ? analysis.cols : {};
    if (state.table) {
      analysis.lines.forEach(function (line) {
        line.cells.forEach(function (c) { if (c !== line.headerCell || analysis.orientation === 'horizontal') c.classList.add('mg-col'); });
        if (line.key) line.headerCell.setAttribute('data-mg-key', line.key);
        else line.headerCell.removeAttribute('data-mg-key');
      });
    }
    if (state.pinned && keys && keys.indexOf(state.pinned) === -1) state.pinned = null;
    if (state.hover && keys && keys.indexOf(state.hover) === -1) state.hover = null;
    apply(state);
  }

  function observeSize(state) {
    if (!window.ResizeObserver || !state.node) return;
    if (state.ro) state.ro.disconnect();
    var lastW = 0;
    state.ro = new ResizeObserver(function (entries) {
      var w = entries[0] && entries[0].contentRect ? entries[0].contentRect.width : 0;
      if (w > 0 && lastW === 0) layout(state.node.querySelector('.mg-svg')); // became visible: exact text widths
      lastW = w;
    });
    state.ro.observe(state.node);
  }

  function clearTable(table) {
    table.classList.remove('mg-table-active');
    table.querySelectorAll('.mg-col, .mg-col-on, [data-mg-key]').forEach(function (c) {
      c.classList.remove('mg-col', 'mg-col-on');
      c.removeAttribute('data-mg-key');
    });
  }

  function apply(state) {
    var key = state.hover || state.pinned || null;
    var node = state.node;
    if (node) {
      node.classList.toggle('is-active', !!key);
      node.querySelectorAll('.mg-m').forEach(function (g) {
        var k = g.getAttribute('data-measure');
        g.classList.toggle('is-on', k === key);
        g.setAttribute('aria-pressed', state.pinned === k ? 'true' : 'false');
      });
      node.querySelectorAll('[data-for]').forEach(function (el) {
        el.classList.toggle('is-on', !!key && el.getAttribute('data-for').split(' ').indexOf(key) !== -1);
      });
    }
    var table = state.table;
    if (table) {
      var lines = key ? (state.cols[key] || []) : [];
      table.classList.toggle('mg-table-active', lines.length > 0);
      var on = [];
      lines.forEach(function (l) { on = on.concat(l.cells); });
      table.querySelectorAll('.mg-col').forEach(function (c) { c.classList.toggle('mg-col-on', on.indexOf(c) !== -1); });
    }
  }

  function keyFrom(state, el) {
    if (!el || !el.closest) return null;
    var g = el.closest('.mg-m');
    if (g && state.node && state.node.contains(g)) return g.getAttribute('data-measure');
    var h = el.closest('[data-mg-key]');
    if (h && state.table && state.table.contains(h)) return h.getAttribute('data-mg-key');
    return null;
  }

  function bind(state) {
    var scope = state.scope;
    scope.addEventListener('pointerover', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      var k = keyFrom(state, e.target);
      if (k !== state.hover) { state.hover = k; apply(state); }
    });
    scope.addEventListener('pointerleave', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      if (state.hover) { state.hover = null; apply(state); }
    });
    scope.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var k = keyFrom(state, e.target);
      if (!k) return;
      e.preventDefault();
      state.pinned = state.pinned === k ? null : k;
      apply(state);
    });
    scope.addEventListener('focusin', function (e) {
      var k = keyFrom(state, e.target);
      var visible = false;
      try { visible = e.target.matches(':focus-visible'); } catch (err) { visible = false; }
      if (k && visible) { state.hover = k; apply(state); }
    });
    scope.addEventListener('focusout', function () {
      if (state.hover && lastPointer !== 'mouse') { state.hover = null; apply(state); }
    });
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        var el = t.nodeType === 1 ? t : t.parentNode;
        if (el && el.closest && el.closest('.mg')) continue;
        schedule(state);
        return;
      }
    }).observe(scope, { childList: true, subtree: true, characterData: true });
  }

  function schedule(state) {
    if (state.timer) return;
    state.timer = setTimeout(function () {
      state.timer = null;
      try { sync(state); } catch (e) { if (window.console) console.warn('[measurement-guide]', e); }
    }, 40);
  }

  // tap: toggle on labels and mapped headers; tap elsewhere clears (desktop uses hover)
  document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, true);
  document.addEventListener('click', function (e) {
    var target = e.target;
    states.forEach(function (state) {
      var k = state.scope.contains(target) ? keyFrom(state, target) : null;
      if (k) {
        if (lastPointer === 'mouse') return;
        state.pinned = state.pinned === k ? null : k;
        state.hover = null;
        apply(state);
      } else if (state.pinned || (state.hover && lastPointer !== 'mouse')) {
        state.pinned = null;
        if (lastPointer !== 'mouse') state.hover = null;
        apply(state);
      }
    });
  });

  function relayoutAll() {
    states.forEach(function (s) { if (s.node) layout(s.node.querySelector('.mg-svg')); });
  }

  function template() {
    if (!tpl || !tpl.isConnected) tpl = document.getElementById('MeasurementGuideTemplate');
    return tpl;
  }

  /* Kiwi scopes: the theme's .sp-kiwi-sizechart wrappers, plus any Kiwi chart rendered elsewhere */
  function findScopes() {
    var out = Array.prototype.slice.call(document.querySelectorAll('.sp-kiwi-sizechart'));
    var extra = Array.prototype.slice.call(document.querySelectorAll('#KiwiSizingChart, .ks-chart-container'));
    extra.forEach(function (el) {
      if (el.closest('.sp-kiwi-sizechart')) return;
      var s = el.closest('#measurment-info-table') || el.parentNode;
      if (s && out.indexOf(s) === -1 && !out.some(function (o) { return o.contains(s); })) out.push(s);
    });
    return out;
  }

  function attachScopes() {
    if (!template()) return;
    findScopes().forEach(function (scope) {
      if (scope.__mgState) { schedule(scope.__mgState); return; }
      var state = { scope: scope, node: null, anchor: null, keys: [], alias: {}, sig: null, table: null, cols: {}, hover: null, pinned: null, timer: null };
      scope.__mgState = state;
      states.push(state);
      bind(state);
      schedule(state);
    });
  }

  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () { scanTimer = null; try { attachScopes(); } catch (e) { if (window.console) console.warn('[measurement-guide]', e); } }, 120);
  }

  function init() {
    attachScopes();
    // the drawer / Kiwi may be (re)rendered later or elsewhere: keep looking for new Kiwi charts
    if (window.MutationObserver && document.body) {
      new MutationObserver(function (records) {
        for (var i = 0; i < records.length; i++) {
          var added = records[i].addedNodes;
          for (var k = 0; k < added.length; k++) {
            var n = added[k];
            if (n.nodeType !== 1 || (n.closest && n.closest('.mg'))) continue;
            if (n.matches && (n.matches('.sp-kiwi-sizechart, #KiwiSizingChart, .ks-chart-container, table, #MeasurementGuideTemplate') ||
                n.querySelector('.sp-kiwi-sizechart, #KiwiSizingChart, .ks-chart-container, table, #MeasurementGuideTemplate'))) { scheduleScan(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayoutAll);
    window.addEventListener('resize', function () { clearTimeout(init.rt); init.rt = setTimeout(function () { relayoutAll(); states.forEach(schedule); }, 150); });
    window.addEventListener('load', scheduleScan);
  }

  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-drawer="eusizeChart"], .ks-tab-header, .ks-tab-headers label, .ks-unit-toggle-label, .ks-unit-toggle')) {
      scheduleScan();
      setTimeout(function () { relayoutAll(); states.forEach(schedule); }, 350);
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Robin 23 Oct: Size Guides page, every drawing with all of its measurements (no size table to match) */
  function initStandalone() {
    document.querySelectorAll('.mg-standalone .mg').forEach(function (node) {
      if (!node.__mgDone) {
        node.__mgDone = true;
        hydrate(node);
        setVisible(node, drawingKeys(node));
      } else {
        layout(node.querySelector('.mg-svg'));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStandalone); else initStandalone();
  window.addEventListener('load', initStandalone);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(initStandalone);
  window.addEventListener('resize', function () { clearTimeout(initStandalone.t); initStandalone.t = setTimeout(initStandalone, 150); });

  window.OrimonoMeasurementGuide = { normalise: normalise, mapHeader: mapHeader, refresh: function () { states.forEach(schedule); } };
})();
